import {useCallback, useEffect, useState} from 'react';
import apiClient2 from "../../../../api/apiClient2";
import apiPaths from "../../../../api/endpoints";
import {ChatQuestion} from '../config';

interface UseChatQuestionsResult {
  questions: ChatQuestion[];
  loading: boolean;
  refetch: () => Promise<void>;
}

const useChatQuestions = (isChild: boolean): UseChatQuestionsResult => {
  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState<ChatQuestion[]>([]);

  const fetchQuestions = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiClient2.get(apiPaths.CHAT_QUESTIONS, {
        params: {isChild},
      });
      const {data} = response;
      setQuestions(data?.data ?? []);
    } catch {
      setQuestions([]);
    } finally {
      setLoading(false);
    }
  }, [isChild]);

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions]);

  return {questions, loading, refetch: fetchQuestions};
};

export default useChatQuestions;
